import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_eslint@9.26.0_jiti@2.4.2__ior_73fjwuwttzoxnjvzb4b2win56q/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/node_modules/.pnpm/@nuxt+ui-pro@1.8.0_jwt-decode@4.0.0_magicast@0.3.5_valibot@1.0.0_typescript@5.8.3__vite@6.3.4_64fygqfqo7kweod43ptbd3lfcu/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}